import { produce } from 'immer';

const initialState = {
  sending: false,
  loading: false,
};

const SET_SENDING = 'SET_SENDING';
export const setSending = {
  type: SET_SENDING,
};

const UNSET_SENDING = 'UNSET_SENDING';
export const unsetSending = {
  type: UNSET_SENDING,
};

const SET_LOADING = 'SET_LOADING';
export const setLoading = {
  type: SET_LOADING,
};

const UNSET_LOADING = 'UNSET_LOADING';
export const unsetLoading = {
  type: UNSET_LOADING,
};

const serverCommunication = (state = initialState, action) =>
  produce(state, (draft) => {
    const { type } = action;
    switch (type) {
      case SET_SENDING:
        draft.sending = true;
        break;
      case UNSET_SENDING:
        draft.sending = false;
        break;
      case SET_LOADING:
        draft.loading = true;
        break;
      case UNSET_LOADING:
        draft.loading = false;
        break;
      default:
        break;
    }
  });

export default serverCommunication;
